import React from 'react';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';
export type SpinnerColor = 'default' | 'secondary' | 'primary' | 'custom';

export interface SpinnerProps {
  size?: SpinnerSize;
  color?: SpinnerColor;
  customColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Unified Spinner component with consistent styling across the application
 * 
 * @example
 * <Spinner size="sm" />
 * <Spinner size="md" color="secondary" />
 * <Spinner size="lg" color="custom" customColor="#ff0000" />
 */
export const Spinner: React.FC<SpinnerProps> = ({
  size = 'sm',
  color = 'default',
  customColor,
  className = '',
  style = {},
}) => {
  const sizeClass = `spinner-${size}`;
  const colorClass = color !== 'custom' ? `spinner-${color}` : '';
  
  const classes = [
    'spinner',
    sizeClass,
    colorClass,
    className
  ].filter(Boolean).join(' ');

  const customStyle: React.CSSProperties = {
    ...style,
    ...(color === 'custom' && customColor ? { borderColor: customColor, borderRightColor: 'transparent' } : {}),
  };

  return (
    <span 
      className={classes}
      style={customStyle}
      aria-label="Loading"
      role="status"
      aria-live="polite"
    />
  );
};

